const KEY = "dh_agent_responses";

function readResponses() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
}

function writeResponses(responses) {
  localStorage.setItem(KEY, JSON.stringify(responses));
}

export function emptyAgentResponse(overrides = {}) {
  return {
    id: "",
    buyerId: "",
    agentId: "",
    property: {
      address: "",
      city: "",
      state: "",
      zip: "",
      mls: "",
      price: "",
      beds: "",
      baths: "",
      sqft: "",
    },
    locationLot: {
      setting: "",
      lotType: [],
      yardSize: "",
      landscaping: "",
      fencing: [],
      driveway: [],
      garage: "",
      hoa: "",
      terrain: [],
      notes: "",
    },
    exterior: {
      porch: [],
      deck: "",
      patio: "",
      outdoorKitchen: "",
      poolSpa: [],
      roof: [],
      siding: [],
      windows: [],
      solar: "",
      notes: "",
    },
    interior: {
      ceilingHeight: "",
      ceilingTypes: [],
      ceilingNotes: "",
      wallTypes: [],
      wallNotes: "",
      flooring: [],
      flooringNotes: "",
      architectural: [],
      architecturalNotes: "",
      kitchenSize: "",
      kitchenPrimaryLayout: "",
      kitchenLayout: [],
      kitchenDetails: [],
      countertops: [],
      cabinets: [],
      kitchenNotes: "",
      bathroomDetails: [],
      bathNotes: "",
      bonusRooms: [],
      bonusNotes: "",
      notes: "",
    },
    systems: {
      hvac: [],
      heating: "",
      cooling: "",
      electrical: "",
      plumbing: "",
      waterHeater: "",
      sewer: "",
      internet: "",
      smartHome: [],
      energy: [],
      notes: "",
    },
    condition: {
      overall: "",
      updates: [],
      roofAge: "",
      hvacAge: "",
      windowsAge: "",
      inspectionFlags: [],
      repairsNeeded: "",
      notes: "",
    },
    summary: {
      matchToBuyer: "",
      strengths: "",
      concerns: "",
      recommendation: "",
      nextSteps: "",
      showingNotes: "",
    },
    createdAt: "",
    updatedAt: "",
    ...overrides,
  };
}

export function listAgentResponses(agentId, excludeAgentId) {
  const all = readResponses();
  let list = agentId ? all.filter((item) => item.agentId === agentId) : all;
  if (!agentId && excludeAgentId) {
    list = list.filter((item) => item.agentId && item.agentId !== excludeAgentId);
  }
  return Promise.resolve(list);
}

export function listAgentResponsesForBuyer(buyerId) {
  return Promise.resolve(readResponses().filter((item) => item.buyerId === buyerId));
}

export function getAgentResponse(id) {
  const found = readResponses().find((item) => item.id === id) || null;
  return Promise.resolve(found ? emptyAgentResponse(found) : null);
}

export function createAgentResponse(data) {
  const responses = readResponses();
  const now = new Date().toISOString();
  const record = emptyAgentResponse({
    ...data,
    id: data.id || crypto.randomUUID(),
    createdAt: now,
    updatedAt: now,
  });
  responses.push(record);
  writeResponses(responses);
  return Promise.resolve(record);
}

export function updateAgentResponse(id, data) {
  const responses = readResponses();
  const index = responses.findIndex((item) => item.id === id);
  if (index === -1) return Promise.reject(new Error("Agent response not found"));
  const next = emptyAgentResponse({
    ...responses[index],
    ...data,
    property: { ...responses[index].property, ...(data.property || {}) },
    locationLot: { ...responses[index].locationLot, ...(data.locationLot || {}) },
    exterior: { ...responses[index].exterior, ...(data.exterior || {}) },
    interior: { ...responses[index].interior, ...(data.interior || {}) },
    systems: { ...responses[index].systems, ...(data.systems || {}) },
    condition: { ...responses[index].condition, ...(data.condition || {}) },
    summary: { ...responses[index].summary, ...(data.summary || {}) },
    id,
    updatedAt: new Date().toISOString(),
  });
  responses[index] = next;
  writeResponses(responses);
  return Promise.resolve(next);
}
